import type { TokenMap } from "@stepfinance/common";

export type { TokenMap };

export enum ChainID {
  MainnetBeta = 101,
  Testnet = 102,
  Devnet = 103,
}
